import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=471a5dfd&lang=pug&"
import script from "./Local.vue?vue&type=script&lang=js&"
export * from "./Local.vue?vue&type=script&lang=js&"
import style0 from "./Local.vue?vue&type=style&index=0&id=471a5dfd&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports